import { ComponentsBoxCondition } from "@omni/types/components/cart/shared/enums/boxCondition.enum";

const toComponents: Record<string, ComponentsBoxCondition> = {
    "ageCondition": ComponentsBoxCondition.AgeCondition,
    "contestCondition": ComponentsBoxCondition.ContestConditions,
    "partnerCondition": ComponentsBoxCondition.PartnerConditions
};

export const BoxConditionTypeMapper = {
    toComponents: (cloudBoxConditionType: string): ComponentsBoxCondition =>
        toComponents[cloudBoxConditionType]
};
